function shipment(state = {
  shipment: [],
  order:[],
  track: "",
  fetching: false,
  fetched: false,
  fetched_track:false,
  fetched_order:false,
  fetchTrackDetail:false,
  error: null,

}, action){
  switch (action.type) {
      case 'GET_SHIPMENT_FULFILLED':{
        return{
          ...state,
          fetching:false,
          fetched:true,
          shipment: action.payload,
        }
      }
      case 'GET_SHIPMENT_FETCHING':{
        return{
          ...state,
          fetching:true,
          fetched:false,
          shipment: action.payload,
        }
      }
      case 'GET_SHIPMENT_REJECTED':{
        return {
          ...state,
          fetched:false,
          error: action.payload,
        }
      }

      case 'GET_ORDER_FULFILLED':{
        return{
          ...state,
          fetched_order:true,
          order: action.payload,
        }
      }
      case 'GET_ORDER_REJECTED':{
        return {
          ...state,
          fetched_order:false,
          error: action.payload,
        }
      }
      case 'GET_TRACK_FETCHING': {
        return {
          ...state,
          fetchTrackDetail: true,
          track: null,
          error: null,
        }
      }
      case 'GET_TRACK_FULFILLED':{
        return{
          ...state,
          fetched_track:true,
          track: action.payload,
          fetchTrackDetail: false,
        }
      }
      case 'GET_TRACK_REJECTED':{
        return {
          ...state,
          fetched_track:false,
          error: action.payload,
          fetchTrackDetail: false,
        }
      }
      case 'REMOVE_TRACK_DETAILS':{
        return{
          ...state,
          track: null,
        }
      }
      case 'RESET_ORDERS':{
        return {
          ...state,
          fetched_order:false,
          fetched:false,
          fetching:false,
        }
      }
        default: break

   }
   return state;
}
export default shipment;



/** WEBPACK FOOTER **
 ** ./src/reducers/shipment.js
 **/